import { render, staticRenderFns } from "./ShipagencytransfersGrid.vue?vue&type=template&id=add5b33a"
import script from "./ShipagencytransfersGrid.vue?vue&type=script&lang=js"
export * from "./ShipagencytransfersGrid.vue?vue&type=script&lang=js"
import style0 from "./ShipagencytransfersGrid.vue?vue&type=style&index=0&id=add5b33a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports